/* eslint-disable no-param-reassign */
import axios from 'axios'
// import Vue from 'vue'
const baseURL = process.env.VUE_APP_BASE_URL

export default {
   namespaced: true,
   state: {
      tahun: new Date().getFullYear(),
      refreshTimestamp: 0,
      stattistik: {
         pbg_year: 0,
         pbg_month: 0,
         slf_year: 0,
         slf_month: 0,
      },
      perBulan: {
         tahun: new Date().getFullYear(),
         data: [],
      },
      perKecamatan: {
         data: [],
      },
      perFungsi: {
         data: [],
      },

   },
   actions: {
      triggerRefresh({ commit }) {
         commit('SET_REFRESH_TIMESTAMP', Date.now())
      },
      setTahun({ commit, state }, tahun = state.tahun) {
         const selectedYear = tahun instanceof Date
            ? tahun.getFullYear()
            : Number(tahun) || new Date().getFullYear()

         if (selectedYear !== state.tahun) {
            commit('SET_TAHUN', selectedYear)
         }

         return selectedYear
      },
      getStatistik({ commit, rootState, state }, tahun = state.tahun) {
         const selectedYear = tahun instanceof Date
            ? tahun.getFullYear()
            : Number(tahun) || new Date().getFullYear()

         rootState.isLoading = true
         return axios.get(`${baseURL}dashboard/simbg/statistik`, {
            params: { year: selectedYear },
         }).then(
            response => {
               const data = response.data && response.data.item
                  ? response.data.item
                  : response.data
               commit('SET_STATISTIK', data || {})

               rootState.isLoading = false
               return data
            },
            () => {
               rootState.isLoading = false
            },
         )
      },
      getPerBulan({ commit, rootState, state }, tahun = state.tahun) {
         const selectedYear = tahun instanceof Date
            ? tahun.getFullYear()
            : Number(tahun) || new Date().getFullYear()

         rootState.isLoading = true
         return axios.get(`${baseURL}dashboard/simbg/perbulan`, {
            params: { year: selectedYear },
         }).then(
            response => {
               const data = response.data || {}
               commit('SET_PER_BULAN', data)

               rootState.isLoading = false
               return data
            },
            error => {
               rootState.isLoading = false
               return Promise.reject(error)
            },
         )
      },
      getPerKecamatan({ commit, rootState, state }, tahun = state.tahun) {
         const selectedYear = tahun instanceof Date
            ? tahun.getFullYear()
            : Number(tahun) || new Date().getFullYear()

         rootState.isLoading = true
         return axios.get(`${baseURL}dashboard/simbg/perkecamatan`, {
            params: { year: selectedYear },
         }).then(
            response => {
               const data = response.data || {}
               commit('SET_PER_KECAMATAN', data)

               rootState.isLoading = false
               return data
            },
            error => {
               rootState.isLoading = false
               return Promise.reject(error)
            },
         )
      },
      getPerFungsi({ commit, rootState, state }, tahun = state.tahun) {
         const selectedYear = tahun instanceof Date
            ? tahun.getFullYear()
            : Number(tahun) || new Date().getFullYear()

         rootState.isLoading = true
         return axios.get(`${baseURL}dashboard/simbg/perfungsi`, {
            params: { year: selectedYear },
         }).then(
            response => {
               const data = response.data || {}
               commit('SET_PER_FUNGSI', data)

               rootState.isLoading = false
               return data
            },
            error => {
               rootState.isLoading = false
               return Promise.reject(error)
            },
         )
      },
   },
   mutations: {

      SET_TAHUN(state, tahun) {
         state.tahun = tahun
      },
      SET_REFRESH_TIMESTAMP(state, timestamp) {
         state.refreshTimestamp = timestamp
      },
      SET_STATISTIK(state, data) {
         state.stattistik = {
            ...state.stattistik,
            ...data,
         }
      },
      SET_PER_BULAN(state, data) {
         state.perBulan = {
            data: Array.isArray(data.data) ? data.data : [],
         }
      },
      SET_PER_KECAMATAN(state, data) {
         state.perKecamatan = {
            data: Array.isArray(data.data) ? data.data : [],
         }
      },
      SET_PER_FUNGSI(state, data) {
         state.perFungsi = {
            data: Array.isArray(data.data) ? data.data : [],
         }
      },

   },
}
